class RewardsPopup extends ModalDialog {
  constructor() {
    super();
    this.wrapper = this.querySelector(".rewards-popup__wrapper");
    this.buttonClose = this.querySelector('[id^="ModalClose-"]');
    this.rewardsBlocks = this.querySelectorAll(".rewards-popup__rewards-block");
    this.rewardsBlocksGiftWrappers = this.querySelectorAll(".rewards-popup__products");
    this.allGiftsIds = Array.from(
      this.querySelectorAll(".rewards-popup__product-link input")
    ).map((input) => input.value);
    this.cta = this.querySelector(".rewards-popup__cta button");
    this.scrollHint = this.querySelector("[data-scroll-hint]");
    this.scrollArrow = this.querySelector("[data-scroll-arrow]");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.excludedProducts = window.excludedProducts || [];
  }

  attachEventListeners() {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      this.updateCart(data.cartData || data.cart);
    });

    document.addEventListener('click', (event) => {
      if (event.target === this) {
        this.hide();
      }
    });
  }

  async updateCart(cart) {
    if (!cart || !cart.total_price) {
      cart = await fetch("/cart.js").then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch cart data");
        }
      });
    }

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;

    this.rewardsBlocks.forEach((block) => {
      const threshold = parseFloat(block.dataset.rewardsThreshold);
      if (totalSpent >= threshold) {
        block.classList.add("active");
      } else {
        block.classList.remove("active");
        const checkedInput = block.querySelector('input:checked');
        if (checkedInput) {
          checkedInput.checked = false;
        }
      }

      const productInputs = block.querySelectorAll(".rewards-popup__product-link input");
      productInputs.forEach((input) => {
        const productId = input.value;
        const isChecked = input.checked;
        const rewardThreshold = input.dataset.rewardThreshold;
        const isInCart = cart.items.some((item) => item.variant_id.toString() === productId && item.properties['_Reward Threshold']?.toString() == `${rewardThreshold}`);

        if (isChecked && !isInCart) {
          input.checked = false;
        }
      });
    });

    this.validateRewards(cart);
    if (this.showPopup(cart)) {
      this.show();
    }
  }

  async validateRewards(cart) {
    if (!cart || !cart.total_price) {
      cart = await fetch("/cart.js").then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch cart data");
        }
      });
    }

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;

    const productsInCart = cart.items.filter((item) =>
      this.allGiftsIds.includes(item.id.toString())
    );

    if (productsInCart.length === 0) {
      return true;
    }

    const updates = {};
    productsInCart.forEach((item) => {
      const productId = item.id.toString();
      const lineItemKey = item.key;
      // const rewardThreshold = this.querySelector(`input[value="${productId}"]`)
      //   ?.dataset.rewardThreshold;
      
      const rewardThreshold = item.properties['_Reward Threshold'];
      
      const thresholdMet = totalSpent >= parseFloat(rewardThreshold);
      if (!thresholdMet) {
        updates[lineItemKey] = 0;
        this.querySelector(`.rewards-popup__product-link input[value="${productId}"]`).checked = false;
      } else if (item.quantity > 1) {
        updates[lineItemKey] = 1;
      }
    });

    const duplicateRewards = this.checkForDuplicateRewards(
      productsInCart,
      cart
    );

    duplicateRewards.forEach((key) => {
      updates[key] = 0;
    });

    if (Object.keys(updates).length > 0) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              this.cart?.renderContents(data);
            });
          } else {
            response.json().then((error) => {
              console.error("Error updating cart:", error);
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
      return false;
    }
    return false;
  }

  checkForDuplicateRewards(productsInCart) {
    const duplicateProductKeys = [];
    
    // Group products by their threshold value
    const thresholdGroups = {};
    
    productsInCart.forEach((item) => {
      const threshold = item.properties['_Reward Threshold'];
      if (threshold) {
        if (!thresholdGroups[threshold]) {
          thresholdGroups[threshold] = [];
        }
        thresholdGroups[threshold].push(item);
      }
    });

    // For each threshold, if there are multiple products, keep only the first one
    Object.values(thresholdGroups).forEach((items) => {
      if (items.length > 1) {
        // Keep the first item, mark all others as duplicates
        items.slice(1).forEach((item) => {
          duplicateProductKeys.push(item.key);
        });
      }
    });
    return duplicateProductKeys;
  }

  showPopup(cart) {
    if (!cart || !cart.total_price) {
      return false;
    }

    const productsInCart = cart.items.filter((item) =>
      this.allGiftsIds.includes(item.id.toString())
    );

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;
    let showPopup = false;

    this.rewardsBlocks.forEach((block) => {
      const threshold = parseFloat(block.dataset.rewardsThreshold);
      const blockProductIds = Array.from(
        block.querySelectorAll(".rewards-popup__product-link input")
      ).map((input) => input.value);

      const productsInBlock = productsInCart.filter((item) =>
        blockProductIds.includes(item.id.toString()) && item.properties['_Reward Threshold'] == `${threshold}`
      );

      if (totalSpent >= threshold && productsInBlock.length == 0 && !document.querySelector('.spin-the-wheel-product')) {
        showPopup = true;
      }
    });

    return showPopup;
  }

  async handleRewardSelection(event) {
    event?.preventDefault();
    this.cta?.querySelector('.loading__spinner').classList.remove('hidden');
    this.cta?.querySelector('span').classList.add('hidden');
    const activeBlocks = Array.from(
      this.querySelectorAll(".rewards-popup__rewards-block.active")
    );

    const selectedProducts = this.querySelectorAll(
      ".rewards-popup__product-link input:checked"
    );

    if (selectedProducts.length == activeBlocks.length) {
      const cart = await fetch("/cart.js");
      if (!cart.ok) {
        console.error("Failed to fetch cart data");
      }

      const cartData = await cart.json();
      const productsInCart = cartData.items.filter((item) =>
        this.allGiftsIds.includes(item.id.toString())
      )
      const prodctsToAdd = Array.from(selectedProducts).filter((input) => {
        const productId = input.value;
        return !productsInCart.some((item) => item.id.toString() === productId && item.properties['_Reward Threshold'].toString() == `${input.dataset.rewardThreshold}`);
      });

      let formData = {
        items: [
          ...Array.from(prodctsToAdd).map((input) => {
            const productId = input.value;
            const rewardThreshold = input.dataset.rewardThreshold;
            return {
              id: productId,
              quantity: 1,
              properties: {
                "_Reward Threshold": `${rewardThreshold}`,
                "Includes": "All Unreleased Products",
              },
            };
          }),
        ],
        sections: this.cart
          ?.getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname,
      };

      this.querySelector('.rewards-popup__inner').style.opacity = '0.5';
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              console.log("Product added to cart:", data);
              this.validateRewards();
              this.cart?.renderContents(data);
              this.hide(false);
            });
          } else {
            response.json().then((error) => {
              console.error("Error adding product to cart:", error);
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        })
        .finally(() => {
          this.cta?.querySelector('.loading__spinner').classList.add('hidden');
          this.cta?.querySelector('span').classList.remove('hidden');
          this.querySelector('.rewards-popup__inner').style.opacity = '';
          return true;
        });
    } else {
      this.cta?.querySelector('.loading__spinner').classList.add('hidden');
      this.cta?.querySelector('span').classList.remove('hidden');
      // alert("Please select a product for each tier.");
      return true; //Changing this to true to allow customers to close the popup without adding gifts to cart since the fallback products get added at checkout
    }
  }

  randomizeBlock(block, button) {
    if (!block?.classList.contains("active") || block.classList.contains("is-randomizing")) {
      return;
    }

    const inputs = Array.from(
      block.querySelectorAll('.rewards-popup__product-link input[type="radio"]')
    );
    const products = Array.from(block.querySelectorAll(".rewards-popup__product"));

    if (!inputs.length || !products.length) {
      return;
    }

    const finalIndex = Math.floor(Math.random() * inputs.length);
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const selectProduct = (index) => {
      products.forEach((product) => product.classList.remove("is-randomizer-highlight"));
      products[index]?.classList.add("is-randomizer-highlight");
      inputs[index].checked = true;
      inputs[index].dispatchEvent(new Event("change", { bubbles: true }));
    };

    if (prefersReducedMotion) {
      selectProduct(finalIndex);
      return;
    }

    const spinSteps = 6 + inputs.length * 2;
    let step = 0;

    const setHighlight = (index) => {
      products.forEach((product) => product.classList.remove("is-randomizer-highlight"));
      products[index]?.classList.add("is-randomizer-highlight");
    };

    block.classList.add("is-randomizing");
    button.disabled = true;

    const finish = () => {
      selectProduct(finalIndex);
      block.classList.remove("is-randomizing");
      button.disabled = false;

      setTimeout(() => {
        products[finalIndex]?.classList.remove("is-randomizer-highlight");
      }, 700);
    };

    const tick = () => {
      if (step < spinSteps) {
        setHighlight(step % inputs.length);
        step += 1;
        const progress = step / spinSteps;
        const delay = Math.round(90 + progress * progress * 110);
        setTimeout(tick, delay);
        return;
      }

      if (step === spinSteps) {
        setHighlight(finalIndex);
        step += 1;
        setTimeout(finish, 220);
        return;
      }
    };

    tick();
  }

  updateScrollArrow() {
    if (!this.scrollHint || !this.wrapper) return;

    const canScroll = this.wrapper.scrollHeight > this.wrapper.clientHeight + 5;
    const atBottom =
      this.wrapper.scrollTop + this.wrapper.clientHeight >=
      this.wrapper.scrollHeight - 5;

    this.scrollHint.classList.toggle("is-hidden", !canScroll || atBottom);
  }

  celebrate() {
    var end = Date.now() + 2 * 1000;

    var colors = ["#710607", "#ffffff", "#E1223C"];
    let zIndex = 2147483647;

    (function frame() {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 70,
        origin: { x: 0 },
        colors: colors,
        zIndex: zIndex,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 70,
        origin: { x: 1 },
        colors: colors,
        zIndex: zIndex,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  show(opener) {
    super.show(opener);
    this.celebrate();
    setTimeout(() => {
      this.wrapper.classList.add("open");
    }, 10);
    document.documentElement.style.overflow = "hidden";
    this.rewardsBlocks.forEach((block) => {
      block.classList.remove('is-pending-selection');
    });
    this.rewardsBlocks.forEach((block) => {
      if (block.classList.contains("active") && !block.querySelector('.rewards-popup__product-link input:checked') && !block.classList.contains('is-active')) {
        block.classList.add('is-pending-selection');
      }
    });


    const firstOpenBlock = this.querySelector(".rewards-popup__rewards-block.is-pending-selection");
    if (firstOpenBlock) {
      firstOpenBlock.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }

    setTimeout(() => this.updateScrollArrow(), 50);
  }

  async hide(close = true) {
    if(close){
      const hidePopup = await this.handleRewardSelection();
      if (!hidePopup) return;
    }
    this.wrapper.classList.remove("open");
    await new Promise(resolve => setTimeout(resolve, 300));
    super.hide();
    document.documentElement.style.overflow = "";
  }

  connectedCallback() {
    this.attachEventListeners();
    this.cta?.addEventListener("click", (event) =>
      this.handleRewardSelection(event)
    );

    this.rewardsBlocks.forEach((wrapper) => {
      wrapper.addEventListener('change', (event) => {
        if (!event.target.matches('.rewards-popup__product-input')) return;

        wrapper.classList.remove('is-pending-selection');

        if(this.querySelector(".rewards-popup__rewards-block.is-pending-selection")){
          this.querySelector(".rewards-popup__rewards-block.is-pending-selection").scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        } else if(!this.querySelector(".rewards-popup__rewards-block.is-pending-selection")){
          this.handleRewardSelection();
        }
      });
    });

    this.querySelectorAll("[data-randomizer-button]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const block = button.closest(".rewards-popup__rewards-block");
        if (block) {
          this.randomizeBlock(block, button);
        }
      });
    });

    this.wrapper?.addEventListener("scroll", () => this.updateScrollArrow());

    this.scrollArrow?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.wrapper?.scrollBy({
        top: this.wrapper.clientHeight * 0.5,
        behavior: "smooth",
      });
    });

    window.addEventListener("resize", () => this.updateScrollArrow());
  }
}
customElements.define("rewards-popup", RewardsPopup);